import { Injectable, Injector } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import {Action, Store} from '@ngrx/store';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ProgressionService } from '../../../../app/shared/services/progression.service';
import {
  GetExecutionPathAction,
  PathwaySelectionsActionTypes, UpdateExecutionPathInStore, UpdateTPNoteInStore,
} from '../actions/pathway-selections.actions';
import { ListItem } from '../../../widgets/models/list-item';
import { of } from 'rxjs/observable/of';
import { SetErrorAction } from '@ispm/shared/store/actions/error.actions';
import * as lodash from 'lodash';


@Injectable()
export class LoadProgressionEffects {


  constructor(private actions$: Actions,
              private injector: Injector, private store$: Store<any>) {
  }

  @Effect()
  loadExecutionHistory$: Observable<Action> = this.actions$
    .pipe(
      ofType<GetExecutionPathAction>(PathwaySelectionsActionTypes.GetExecutionPath),
      switchMap(_ => this.loadProgression())
    );

  private loadProgression() : Observable<any>{
      // init tp-note value in the store to avoid the blinking of the old value when entering T&T
      this.store$.dispatch(new UpdateTPNoteInStore(''));
      return this.getProgressionService().search('BpmnExecutionHistory')
          .pipe(
              switchMap(progressions => {
                  if (progressions.length > 0) {
                      const data = progressions[0].data.additionalProperties;
                      return [
                          new UpdateExecutionPathInStore({ history: data.history as ListItem[]}),
                          new UpdateTPNoteInStore( lodash.get(data, 'tp-note.text', ''))
                      ];
                  }
                  return [];
              }),
              catchError(error => of(new SetErrorAction({
                  error: error.message,
                  devMessage: 'loadExecutionHistory$: Failed to search for BpmnExecutionHistory Progression',
                  userMessage: 'Failed to load pathway execution history'
              })))
          )
  }
  private getProgressionService(): ProgressionService {
    return this.injector.get(ProgressionService);
  }

}
